/* @flow */

import { relatedRecurringItemSelector, itemByIdSelector } from './selectors-common';


export const isTodoDetailOpenSelector = (state: AppState) => {
  const { recurringId, itemId } = state.routing.locationBeforeTransitions.query;
  return !!recurringId || !!itemId;
};

export const openItemSelector = (state: AppState) => {
  const { recurringId, itemId } = state.routing.locationBeforeTransitions.query;
  return recurringId
    ? relatedRecurringItemSelector(
      state,
      recurringId,
    )
    : itemByIdSelector(state, itemId);
};

export * from './selectors-common';
